module.exports = __webpack_public_path__ + "img/teaser_004.6904d397.png";